var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    raw data, type = "+_vm._s(_vm.model && _vm.model.type)+"\n    "),_c('json-viewer',{attrs:{"value":_vm.model}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }